const Loading = ({ fullScreen = true }: { fullScreen?: boolean }) => {
  return (
    <div className={'w-full h-screen flex justify-center items-center'}>
      <div className="dot-flashing"></div>
    </div>
  );
};

export default Loading;
